var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrizzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1902 25.4582C13.8654 23.9367 10 19.3821 10 14C10 7.37258 15.861 2 23.0909 2C27.9364 2 32.167 4.41319 34.4305 8H37C41.9706 8 46 12.0294 46 17C46 21.9706 41.9706 26 37 26H22.2727C21.1899 26 20.1517 25.8088 19.1902 25.4582Z",
    fill: "#D9DBE9",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 31.5156L6.5 30.6496",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24.5879L10.25 24.1549",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3613 39.2305L11.6113 38.7975",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3613 34.0352L14.6113 33.6021",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3613 28.8379L18.8613 26.2398",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4727 42.1816L19.7227 41.7486",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9727 36.1191L24.4727 33.5211",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7227 27.8926L27.9727 27.4596",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5835 39.9355L30.8335 39.5025",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3335 33.4414L35.8335 30.8433",
    stroke: "#6E7191",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrizzle);
export default __webpack_public_path__ + "static/media/drizzle.f8253a643aec61448b9727d2d5bb24c4.svg";
export { ForwardRef as ReactComponent };